import { ReactNode } from 'react'

import { Button, Flex } from '@sequencehq/core-components'
import { GreyGrey30 } from '@sequencehq/core-components'

type Props = {
  forward: ReactNode
  back: ReactNode
}

export const StepControlsComponent = ({ back, forward }: Props) => (
  <Flex
    borderTop={`${GreyGrey30} 1px solid`}
    padding="8px"
    justifyContent="flex-end"
  >
    <Flex gap="8px">
      {back}
      {forward}
    </Flex>
  </Flex>
)

const Back = ({
  disabled = false,
  onClick,
  label,
  keyboardShortcut
}: {
  disabled?: boolean
  onClick: () => void
  label: string
  keyboardShortcut?: string[]
}) => (
  <Button
    variant="secondary"
    disabled={disabled}
    onClick={onClick}
    keyboardShortcut={keyboardShortcut}
    data-testid="stepControls.back"
  >
    {label}
  </Button>
)

const Forward = ({
  disabled = false,
  onClick,
  label,
  keyboardShortcut
}: {
  disabled?: boolean
  onClick: () => void
  label: string
  keyboardShortcut?: string[]
}) => (
  <Button
    variant="primary"
    disabled={disabled}
    onClick={onClick}
    keyboardShortcut={keyboardShortcut}
    data-testid="stepControls.forward"
  >
    {label}
  </Button>
)

export const StepControls = Object.assign(StepControlsComponent, {
  Back,
  Forward
})
